// Cantidades y listas de nombres, como las escribe toda la pantalla de Updates.

export const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

// "50.000": los miles con punto, como se escriben acá, sin depender del idioma del navegador.
export const thousands = (n) => String(n).replace(/\B(?=(\d{3})+$)/g, '.');

// "PCM", "PCM y TEC", "PCM, TEC y GEO" ("e" delante de un nombre que empieza con i).
export const andList = (names) => {
    if (names.length < 2) return names.join('');
    const last = names[names.length - 1];
    return `${names.slice(0, -1).join(', ')} ${/^h?i/i.test(last) ? 'e' : 'y'} ${last}`;
};

// Hasta cinco clientes se nombran; si son más se cuentan, y la lista completa queda en un tooltip o detrás de "ver detalle".
export const MAX_NAMED = 5;
export const namedOrCount = (names) => names.length > MAX_NAMED ? plural(names.length, 'cliente', 'clientes') : names.join(', ');
